import React from 'react'

const Reports = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Reports</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active">Reports</li>
          </ol>
        </nav>
      </div>{/* End Page Title */}
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Reports</h5>
                <p>Reports will be displayed here.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Reports

